.atm_26_1j28jx2{background:transparent;}
.atm_3f_5l98or{border:1px solid #A1A8B0;}
.atm_5j_1y44olf{border-radius:4px;}
.atm_7l_1hutuam{color:#202328;}
.atm_uc_1r5axao{transition:background 250ms ease-out,border-color 250ms ease-out;}
.atm_19kskpn_118lp2q:hover,.atm_19kskpn_118lp2q:focus{background:#F4F5F7;}
.atm_1u6t0zu_118lp2q.atm_1u6t0zu_118lp2q:hover,.atm_1u6t0zu_118lp2q.atm_1u6t0zu_118lp2q:focus{border-color:#F4F5F7;}
.atm_1kevezh_1j28jx2:active{background:transparent;}
.atm_iiao3o_1hutuam.atm_iiao3o_1hutuam:active{border-color:#202328;}
.atm_oln6rx_1x778eo:disabled{background:white;}
.atm_j9qr6e_j1e0tf.atm_j9qr6e_j1e0tf:disabled{border-color:#CED3DA;}
.atm_1yfe54e_j1e0tf:disabled{color:#CED3DA;}
.atm_7l_9ztun4{color:#DD3131;}
